export const LOAD_CITY = "LOAD_CITY";
export const ADD_CITY = "ADD_CITY";
export const UPDATE_CITY = "UPDATE_CITY";
export const DELETE_CITY = "DELETE_CITY";
export const CLEAR_CITY = "CLEAR_CITY";
export const DEFAULT_CITY = "DEFAULT_CITY";
export const LOAD_DELIVERY_OPTIONS = 'LOAD_DELIVERY_OPTIONS';
export const CLEAR_DELIVERY_OPTIONS = "CLEAR_DELIVERY_OPTIONS";
